import { Badge } from "@chakra-ui/react"
import { AssetKind } from "@hydrologiq/gql/graphql"

export const toText = (kind: AssetKind | string) => {
  switch (kind) {
    case "RemoteMonitoring":
      kind = "RemoteMonitoringSystem"
      break
    case "GasManagement":
      kind = "GasManagementSystem"
      break
  }
  return kind
    .toString()
    .replace(/[A-Z&]/g, " $&")
    .trim()
}

const Kind = ({ kind }: { kind: AssetKind }) => {
  const text = toText(kind)
  return <Badge>{text}</Badge>
}

export default Kind
